import type { AnyRoute } from "@tanstack/react-router"

import { router } from "../router"

export async function prefetchSessionRoutes(steps: Array<{ stepType: string }>) {
  const routes = router.routesByPath

  const promises: Promise<unknown>[] = []

  const chunk = (path: keyof typeof routes) => {
    // loadRouteChunk takes a single route, so pathful layout parents have to be walked explicitly.
    // Without them a child route cannot render offline even though its own chunk is here.
    let route: AnyRoute | undefined = routes[path]

    while (route) {
      // loadRouteChunk returns undefined when the chunk is already loaded
      const promise = router.loadRouteChunk(route)
      if (promise) promises.push(promise)

      route = route.parentRoute
    }
  }

  // always needed
  chunk("/$sessionId/final-check")
  chunk("/$sessionId/intro/$step")
  chunk("/$sessionId/permissions-guide/")

  // GDPR consent
  if (steps.some((s) => s.stepType === "GDPRConsent")) {
    chunk("/$sessionId/consent")
  }

  // Car views
  if (steps.some((s) => s.stepType === "VehiclePhoto")) {
    chunk("/$sessionId/guide/$step")
  }

  // Damage
  if (steps.some((s) => s.stepType === "Damage")) {
    chunk("/$sessionId/damage/intro")
    chunk("/$sessionId/damage/new")
    chunk("/$sessionId/damage/add-more")
    chunk("/$sessionId/damage/edit/$photoId")
  }

  // Claim
  if (steps.some((s) => s.stepType === "Claim")) {
    chunk("/$sessionId/claim/new")
    chunk("/$sessionId/claim/overview")
    chunk("/$sessionId/claim/photos/select")
    chunk("/$sessionId/claim/photos/$photoId/new-marker")
    chunk("/$sessionId/claim/markers/$markerId/details")
  }

  // ExtraEquipment
  if (steps.some((s) => s.stepType === "ExtraEquipment")) {
    chunk("/$sessionId/extra-equipment/select")
  }

  // Documents
  if (steps.some((s) => s.stepType === "DocumentPhoto")) {
    chunk("/$sessionId/documents/intro")
    chunk("/$sessionId/documents/$step")
  }

  // ExtraClientData
  if (steps.some((s) => s.stepType === "ExtraClientData")) {
    chunk("/$sessionId/extra-client-data")
  }

  // Video
  if (steps.some((s) => s.stepType === "VehicleVideo")) {
    chunk("/$sessionId/video/$step")
  }

  await Promise.allSettled(promises)
}
